import axios from 'axios'

const api = axios.create({
  baseURL: 'https://api.3d.r2u.io/v1/customers',
})

export interface CustomerData {
  logoUrl: string
  name: string
}

async function getCustomerDataFromSDK(
  customerId: string
): Promise<CustomerData> {
  try {
    const { R2U } = window

    const customer = await R2U.customer.getData(customerId)
    if (customer) {
      return { logoUrl: customer.logoUrl, name: customer.name }
    }

    return null
  } catch {
    return null
  }
}

export async function getCustomerData(
  customerId: string
): Promise<CustomerData> {
  try {
    const cachedCustomer = await getCustomerDataFromSDK(customerId)

    if (cachedCustomer) {
      return cachedCustomer
    }

    const response = await api.get(customerId)
    return response.data as CustomerData
  } catch (error) {
    return { logoUrl: '', name: '' } as CustomerData
  }
}
